<audio
  [src]="src$ | async"
  controls
  [attr.data-testid]="'audio-player'"
></audio>
